import { SyntheticEvent, useEffect, useState } from "react";
import InputStyles from "./Input.module.scss";
import { InputPropsType } from "./Input.types";
import { DriveBtn } from "../Buttons/Buttons";
import { IconButton } from "@mui/material";
import Divider from "@mui/material/Divider";
import newChatIcon from "../../assets/images/add_circle.svg";
import Tooltip from "../Tooltip/Tooltip";

const Input = ({
  containerClasses = InputStyles.inputContainer,
  inputTagClasses = InputStyles.inputTag,
  handlers = {
    onChange: () => {},
    onKeyDown: () => {},
  },
  inputText,
  placeholder,
  disabled,
  frontImage,
  style,
  containerStyle,
  endImage,
  endImageClick,
  driveImage,
  driveImgClick,
  openingPicker,
  enableNewChat,
  onNewChatClick,
}: InputPropsType) => {
  const [text, setText] = useState("");

  const handleOnChange = (e: SyntheticEvent) => {
    const value = (e.target as HTMLInputElement).value;
    setText(value);
    if (handlers.onChange) handlers.onChange(value);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent) => {
    handlers.onKeyDown &&
      handlers.onKeyDown({
        key: e.key,
        value: text,
      });
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (typeof inputText === "string") setText(inputText);
  }, [inputText]);

  const cursorPointer = disabled ? "" : "cursor-pointer";

  return (
    <div className={containerClasses} style={containerStyle}>
      {frontImage && <img src={frontImage} alt="" />}
      <input
        className={inputTagClasses + " " + cursorPointer}
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={text}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      />
      <div className={InputStyles.buttons}>
        {driveImage && (
          <DriveBtn
            onClick={() => driveImgClick && driveImgClick()}
            loading={openingPicker}
            disabled={openingPicker}
          />
        )}
        {endImage && (
          <img
            src={endImage}
            alt=""
            onClick={() => endImageClick && endImageClick()}
            style={
              endImageClick && text
                ? {
                    cursor: "pointer",
                  }
                : {}
            }
          />
        )}

        {enableNewChat && (
        <Tooltip title="New Chat" placement="right">
          <div className={InputStyles.dividerNewChatWrapper}>
            <Divider orientation="vertical" variant="middle" flexItem sx={{marginLeft: "16px", background: "#D9D9D9",}} />
            <IconButton onClick={() => onNewChatClick && onNewChatClick()}><img src={newChatIcon} alt=""/></IconButton>
          </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default Input;
